// Module
var code = "<group-users-list></group-users-list>";
// Exports
module.exports = code;